import {
  BKJCheckboxListItem,
  BKJSelect,
  BKJSelectSearchControls,
} from '@bookjane2/bookjane-design-library';
import { useTranslation } from 'hooks/useTranslation';
import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';
import { IBKJSelectRenderOptionsProps } from '@bookjane2/bookjane-design-library/lib/components/BKJSelect/BKJSelect.types';
import { FC, Fragment } from 'react';
import { DropdownOptionType } from 'types/common.types';
import { employmentStatusesTypeDropdownOptions } from './EmploymentStatusesTypeSelectInput.constants';

export const EmploymentStatusesTypeSelectInput: FC<{
  value: string[];
  onChange: ChangeFunctionType;
  name: string;
  options?: DropdownOptionType[];
  disabled?: boolean;
}> = ({
  name,
  value,
  onChange,
  options = employmentStatusesTypeDropdownOptions(),
  disabled = false,
}) => {
  const { t, i18n } = useTranslation();
  const RenderOptions: FC<IBKJSelectRenderOptionsProps> = (props) => {
    const isAllSelected = props.selected.length === options.length;
    return (
      <Fragment>
        <BKJSelectSearchControls
          locale={i18n.language}
          numSelected={props.selected.length}
          isAllSelected={isAllSelected}
          onSelectAll={() => {
            isAllSelected
              ? props.onChange({
                  target: {
                    name: name,
                    label: [],
                    value: [],
                  },
                })
              : props.onChange({
                  target: {
                    name: name,
                    label: options.map(({ label }) => label),
                    value: options.map(({ value }) => value),
                  },
                });
          }}
        />
        <div>
          {options.map((opt) => {
            const { type, ...restProps } = props;
            return <BKJCheckboxListItem {...restProps} {...opt} />;
          })}
        </div>
      </Fragment>
    );
  };

  return (
    <BKJSelect
      moreValuesLabel={t('MORE')}
      options={options}
      type="Multiple"
      variant="GreyOutlinedPillClear"
      placeholder={t('dashboard:ALL_EMPLOYMENT_STATUSES')}
      dropdownWidth="358px"
      dropdownPlacement="bottom-start"
      name={name}
      onChange={onChange}
      value={value}
      renderOptions={RenderOptions}
      disabled={disabled}
    />
  );
};
